module.exports = __webpack_public_path__ + "static/favicon.ff47c910.ico";


//////////////////
// WEBPACK FOOTER
// ./static/favicon.ico
// module id = 326
// module chunks = 114276838955818